import {
  AnimationComponent,
  Box,
  Grid2,
  LockIcon,
  Show,
  Tab,
  Tabs,
  Typography,
} from "components";
import DashboardLayout from "layouts/DashboardLayout";
import React, { lazy } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";

// Lazy load all components
const UploadManager = lazy(() => import("Pages/UploadManager"));
const CustomBrokerImport = lazy(() => import("Pages/CustomBrokerImport"));
const ReconManager = lazy(() => import("Pages/ReconManager"));

const ImportsMenu = () => {
  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);
  const { tabValueOfImport } = useAppSelector((state) => state?.app?.tab);

  const tabs = [
    {
      label: "Import Manager",
      component: UploadManager,
      canAccess: true,
    },
    {
      label: "Recon Manager",
      component: ReconManager,
      canAccess: userData?.grantAccess,
    },
    userData?.userRole === UserRoleTypes.advisor &&
      userData?.brokerSupport?.adityaBirlaSupport && {
        label: "Import from Broker",
        component: CustomBrokerImport,
        canAccess: userData?.grantAccess,
      },
  ].filter(Boolean);

  return (
    <DashboardLayout title="Dashboard">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              sx={{
                "& .MuiTabs-flexContainer": {
                  backgroundColor: "var(--white)",
                },
              }}
              onChange={(e, val) => {
                dispatch(TAB({ tabKey: "tabValueOfImport", tabValue: val }));
              }}
              value={tabValueOfImport}
            >
              {tabs.map((tabItem, index) => (
                <Tab
                  key={index}
                  disabled={!tabItem.canAccess}
                  label={
                    <Box display={"flex"} gap={1}>
                      <Typography>{tabItem.label}</Typography>
                      {!tabItem.canAccess && (
                        <LockIcon width={16} height={16} />
                      )}
                    </Box>
                  }
                  disableRipple
                />
              ))}
            </Tabs>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tabItem, index) => (
            <Show.When key={index} isTrue={tabValueOfImport === index}>
              <AnimationComponent>
                {React.createElement(tabItem.component)}
              </AnimationComponent>
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default ImportsMenu;
